// extracted by mini-css-extract-plugin
export default {"container":"LoyaltyLevelIcon-module_container_Dby6qu","icon":"LoyaltyLevelIcon-module_icon_JMZFZe","label":"LoyaltyLevelIcon-module_label_qWwW_6"};